import { RESET_FORM } from '../actionTypes';
import { supplierIntegrationsActions } from '../reducer';

export default () => supplierIntegrationsActions[RESET_FORM]();
